import { NextStepManager } from '../../flow-management/NextStepManager';
import { Data } from '../../signup-data/DATA';
import { ManagementLevel } from '../../signup-data/ManagementLevelOption';
import { bulkSetSignupDataAndSetValid } from '../../store/signup-data/action-creators';
import { Step } from '../../views/Step';
export const BranchACQ140CompanySize = {
  name: 'BranchACQ140CompanySize',
  stateCheck: () => {
    return false; // (
    //   getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One &&
    //   getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [
    //     ExperimentParameterGroup.Variant_A,
    //     ExperimentParameterGroup.Variant_B,
    //   ])
    // );
  },
  rebuildFlow: (flow, state, dispatch) => {
    dispatch(bulkSetSignupDataAndSetValid({
      [Data.ManagementLevel]: ManagementLevel.Owner
    }));
    const nextSteps = NextStepManager.removeSteps(Step.ManagementLevel)(flow);
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.CompanySize,
  afterData: null,
  afterStep: null
};